export function isJwtExpired(token: string): boolean {
  try {
    if (!token) {
      return true
    }
    const payload = JSON.parse(atob(token.split('.')[1])) // берём middle часть
    const exp = payload.exp

    if (!exp) return true

    const now = Math.floor(Date.now() / 1000)
    return exp < now
  } catch (err) {
    return true
  }
}
